<template>
  <div class="error">
    <img class="errorPic" src="./../../assets/img/error-null.png" alt="" />
    <span class="sorry">
      <van-icon
        name="warning"
        color="rgba(226, 49, 48, 1)"
        size="20"
        style="margin-right: 0.1rem"
      />Sorry
    </span>
    <span class="sorrryAbout"> 抱歉，你访问的页面地址有误，或者该页面不存在 </span>
    <div class="text-cent">
      <van-button size="normal" class="text-btn" @click="goback()">返回上一页</van-button>
      <van-button size="normal" class="text-btn text-home" @click="gohome()">返回首页</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "error",
  data() {
    return {};
  },
  methods: {
    goback: function() {
      history.go(-1);
    },
    gohome: function() {
      this.$router.push({ path: "/" });
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped>
.error {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;
  .van-button__content {
    color: #e23331;
  }
  img {
    width: 5.04rem;
    height: 3.76rem;
  }

  .sorry {
    display: flex;
    align-items: center;
    font-size: 0.3rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262626;
    line-height: 0.48rem;
    margin-top: 0.2rem;
  }

  .sorrryAbout {
    font-size: 0.24rem;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: rgba(38, 38, 38, 0.5);
    line-height: 0.42rem;
    margin-top: 0.1rem;
  }

  .visit-the {
    width: 4rem;
    height: 0.96rem;
    background: linear-gradient(111deg, #e23130 0%, #e23130 100%);
    border-radius: 0.48rem;
    font-size: 0.3rem;
    font-weight: 500;
    color: #ffffff;
    line-height: 0.96rem;
    text-align: center;
    margin-top: 0.2rem;
  }

  .text-cent {
    width: 100%;
    box-sizing: border-box;
    padding: 0 0.86rem;
    margin-top: 0.8rem;
    display: flex;
    justify-content: space-between;
    .text-btn {
      width: 2.68rem;
      height: 0.8rem;
      background: #fdf5f5;
      border-radius: 0.5rem;
      border: 0.02rem solid #e23331;
      font-size: 0.3rem;
      font-weight: 500;
      color: #e23331;
      line-height: 0.42rem;
    }

    .text-home {
      background: linear-gradient(111deg, #e23130 0%, #e23130 100%);
      color: rgba(255, 255, 255, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/error.vue